import { type App, inject } from 'vue'
import { getWindow } from '@/helpers/globals.ts'

export interface IsIOSPlugin {
    isIOS: boolean
}

const key = '__plugin_is_ios'

export function installIOS(
    app: App,
    userAgent: string | undefined
): IsIOSPlugin {
    const isIOS = getIsIOS(userAgent)

    const plugin: IsIOSPlugin = {
        isIOS,
    }

    app.provide(key, plugin)

    return plugin
}

function useIsIOSPlugin(): IsIOSPlugin {
    return inject(key) as IsIOSPlugin
}

export function useIsIOS(): boolean {
    return useIsIOSPlugin().isIOS
}

function getIsIOS(userAgent: string | undefined) {
    if (!userAgent) {
        return false
    }

    if (/iP(?:ad|hone|od)/.test(userAgent)) {
        return true
    }

    const window = getWindow()

    if (window && /iPad|Macintosh/.test(window?.navigator.userAgent)) {
        // The new iPad Pro Gen3 does not identify itself as iPad, but as Macintosh.
        // https://github.com/vueuse/vueuse/issues/3577
        return window?.navigator?.maxTouchPoints > 2
    }

    return false
}
